<template>
  <div v-if="!loaded" v-html="info" :style="infoStyle" />
  <div v-else>
    <div v-if="formData.layout === layouts.SINGLE">
      <div class="container">
        <div v-if="contentTypeEvent" class="row justify-content-md-center">
          <div class="post col-md-8">
            <single-event :initialData="this.serverData[this.formData.selectedIndex]" />
            <div class="post-details">
              <div class="posts-nav d-flex justify-content-between align-items-stretch flex-column flex-md-row">
                <div @click="handleChangeSelectedIndex(-1)" class="prev-post text-left d-flex align-items-center">
                  <div class="text">
                    <b-icon icon="chevron-left"></b-icon>
                    <strong class="text-primary">Zurück</strong>
                    <h6>{{ serverData[formData.prevIndex].fragments.title }}</h6>
                  </div>
                </div>
                <div @click="handleChangeSelectedIndex(1)" class="next-post text-right d-flex align-items-center justify-content-end">
                  <div class="text"><strong class="text-primary">Weiter</strong>
                    <b-icon icon="chevron-right"></b-icon>
                    <h6>{{ serverData[formData.nextIndex].fragments.title }}</h6>
                  </div>
                </div>
              </div>
              <div class="posts-nav d-flex justify-content-between align-items-stretch flex-column flex-md-row">
                <div @click="handleSetTable()" class="prev-post text-left d-flex align-items-center">
                  <div class="icon prev">
                    <b-icon icon="chevron-double-left"></b-icon>
                  </div>
                  <div class="text">
                    <strong class="text-primary">Zurück zur Startseite</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="formData.layout === layouts.TABLE">
      <div class="container">
        <div v-if="contentTypeEvent" class="row">
          <event-listed-medium v-for="(sd, ndx) in serverData" :key="sd.key"
            :initialData="sd" :listIndex="ndx" @event-listed-selected="handleCmpnSelected($event)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import config from '@/config'
import { LAYOUT_DEFS, ERROR_DEFS, CONTENT_TYPE_DEFS } from '@/service/utils/constants'

export default {
  name: 'gl-content-list',
  version: '0.0.1',
  inject: ['contentType', 'instKey', 'keyListFilter', 'tagListFilter'],
  props: {}, // props
  components: {
    EventListedMedium: () => import('@/components/glcwc-content/EventListedMedium'),
    SingleEvent: () => import('@/components/glcwc-content/SingleEvent')
  }, // components
  data () {
    return {
      loaded: false,
      info: '... loading content!',
      infoStyle: { 'text-align': 'left', color: 'black' },
      layouts: LAYOUT_DEFS,
      formData: {
        layout: LAYOUT_DEFS.TABLE,
        selectedIndex: 0,
        nextIndex: 0,
        prevIndex: 0
      }
    }
  }, // data
  /* ----- vuejs hooks ----- */
  async mounted () {
    if ((!this.instKey()) || (!this.keyListFilter() && !this.tagListFilter())) {
      this.info = ERROR_DEFS.CONFIG
      this.infoStyle.color = 'red'
    } else {
      try {
        let _listFilter
        if (this.tagListFilter() && this.tagListFilter().length > 0) {
          _listFilter = '/type/' + this.contentType + '/tagListFilter/' + this.tagListFilter()
        } else if (this.keyListFilter() && this.keyListFilter().length > 0) {
          _listFilter = '/keyListFilter/' + this.keyListFilter()
        } else {
          throw 'Empty or no list filters!'
        }
        const _resp = await axios.get(config.glapiBaseUri + '/content/' +
          this.instKey() + _listFilter)
        if (_resp.data && _resp.data.status === 'success') {
          this.serverData = _resp.data.payload.content
          // if (this.genSeo) {
          //   try {
          //     const _orgaResp = await axios.get(config.glapiBaseUri + '/inst/' +
          //       this.instKey + '/orga/' + this.orgaKey)
          //     if (_orgaResp.data && _orgaResp.data.status === 'success') {
          //       this.formData.orga = _orgaResp.data.payload.orga
          //     }
          //   } catch (e) {
          //     console.log('TRACE-REMOVE: BlogPostList.mounted: error reading orga! exception is: ', e)
          //   }
          // }
        } else {
          throw ERROR_DEFS.SERVER_API
        }

        this.loaded = true
        // for delete // this.formData.layout = this.layout
        // if (this.layout === LAYOUT_DEFS.SINGLE) {
        //   this.handleChangeSelectedIndex(this.selectedIndex, false)
        // } else {
        //   this.resetJsonld()
        // }
      } catch (e) {
        console.error('ERROR: ContentList.mounted: exception is: ', e)
        this.info = ERROR_DEFS.ERVER_API
        this.infoStyle.color = 'red'
      }
    }
  }, // mounted
  computed: {
    contentTypeEvent: function () {
      return this.contentType === CONTENT_TYPE_DEFS.EVENT
    }
  }, // computed
  watch: {}, // watch
  methods: {
    /* ----- handler methods ----- */
    handleSetTable () {
      // this.$emit('blog-post-details')
      this.formData.layout = LAYOUT_DEFS.TABLE
      // if (this.genSeo){
      //   this.resetJsonld()
      // }
    }, // handleSetTable
    handleCmpnSelected (ev) {
      console.log('TRACE-REMOVE: handleCmpnSelected: ev is: ', ev)
      this.formData.layout = LAYOUT_DEFS.SINGLE
      this.formData.selectedIndex = 0
      this.handleChangeSelectedIndex(ev)
    }, // handleCmpnSelected
    handleChangeSelectedIndex (change, emit = true) {
      let _change = change
      if (Math.abs(change) >= this.serverData.length) {
        _change = change % this.serverData.length
      }
      if ((this.formData.selectedIndex + _change) >= (this.serverData.length - 1)) {
        this.formData.selectedIndex = ((this.formData.selectedIndex + _change) % this.serverData.length)
      } else if ((this.formData.selectedIndex + _change) < 0) {
        this.formData.selectedIndex = this.serverData.length + _change
      } else {
        this.formData.selectedIndex += _change
      }
      if ((this.formData.selectedIndex + 1) > (this.serverData.length - 1)) {
        this.formData.nextIndex = 0
      } else {
        this.formData.nextIndex = this.formData.selectedIndex + 1
      }
      if ((this.formData.selectedIndex - 1) < 0) {
        this.formData.prevIndex = this.serverData.length - 1
      } else {
        this.formData.prevIndex = this.formData.selectedIndex - 1
      }
      console.log('TRACE-REMOVE: placeholder emit: ', emit)
      // if (emit) {
      //   this.$emit('blog-post-details', this.serverData[this.formData.selectedIndex].key)
      // }
      // if (this.genSeo) {
      //   this.resetJsonld()
      // }
    } // handleChangeSelectedIndex
  } // methods
}
</script>

<style lang="css" scoped>
.next-post, .prev-post {
  cursor: pointer;
}
</style>
